// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { sparseAssetSchema } from '@/asset/api/types';
import {
  sparseItemSchema,
  sparseLocationWithParentSchema,
} from '@/sparse/api/types';
import { dateSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

/**
 * Schema for an assembly item (parts used).
 * Uses flattened structure with embedded item properties.
 */
const assemblyItemSchema = sparseItemSchema.extend({
  actualQuantity: z.number(),
  expectedQuantity: z.number(),
  reason: z.string().nullable(),
  serials: z
    .array(z.string())
    .nullable()
    .transform((v) => v ?? []),
});

export type AssemblyItem = z.infer<typeof assemblyItemSchema>;

const sparseShipmentSchema = z.object({
  id: z.string().uuid(),
  key: z.string(),
  shipmentNumber: z.string(),
});

export const assemblySchema = z.object({
  id: z.string().uuid(),
  key: z.string(),
  internalId: z.string(),
  name: z.string().nullable(),
  buildDate: dateSchema,
  location: sparseLocationWithParentSchema,
  asset: sparseAssetSchema.nullable(),
  partsUsed: z.array(assemblyItemSchema),
  note: z.string().nullable(),
  item: sparseItemSchema,
  hasDeviations: z.boolean(),
  intendedAssetSerial: z.string().nullable(),
  shipment: sparseShipmentSchema.nullable(),
});

export type Assembly = z.infer<typeof assemblySchema>;

export const assemblyListingSchema = z.object({
  results: z.array(assemblySchema),
  totalCount: z.number(),
});
